<template>
  <div class="teacherCard">
    <div class="avatar">
      <el-image
        class="img"
        :src="info.teacherPhotoUrl"
        fit="cover"
        @error.once="reloadImg(info.teacherPhotoUrl)"
      ></el-image>
      <div class="tip" v-if="info.isRecommend !== 0">
        <span class="txt">{{ $t('common.recommend') }}</span>
      </div>
    </div>
    <div class="btns">
      <router-link
        :to="{ path: '/teachers/teacherDetail', query: { id: info.teacherId } }"
        class="ui-btn blue"
        >{{ $t('common.teacherinfo') }}</router-link
      >
      <router-link
        :to="{ path: '/teachers/appointment', query: { id: info.teacherId } }"
        class="ui-btn"
        v-if="showOrder"
        >{{ $t('common.order') }}</router-link
      >
    </div>
    <div class="info">
      <p class="name">
        <span class="txt">{{ info.teacherName }}</span>
      </p>
      <p>
        <span class="tag" v-if="info.teacherLevel === 2">{{
          $t('common.Higher')
        }}</span>
        <span class="tag" v-else-if="info.teacherLevel === 3">{{
          $t('common.Super')
        }}</span>
        <span class="tag" v-else>{{ $t('common.Standard') }}</span>
        <span
          v-if="[95, 65, 58].includes(info.teacherId)"
          :class="`video-${$i18n.locale}`"
          class="video"
          @click="
            $router.push({
              path: '/teachers/teacherDetail',
              query: { id: info.teacherId, tab: 2 },
            })
          "
        ></span>
      </p>
      <!-- <p v-if="info.languageList"><span class="lab">{{$t("form.language")}}：</span>{{info.languageList}}</p> -->
      <p>
        <span class="lab">{{ $t('form.univercity') }}{{ $t('colon') }}</span>
        <span>{{ info.universitys.replace(',',', ') }}</span>
      </p>
      <p>
        <span class="lab">{{ $t('form.college') }}{{ $t('colon') }}</span>
        <span>{{ info.colleges }}</span>
      </p>
      <p v-if="info.education !== 0">
        <span class="lab">{{ $t('form.education') }}{{ $t('colon') }}</span
        ><span>{{ getEducation(info.education) }}</span>
      </p>
      <p v-if="info.courseName">
        <span class="lab">{{ $t('form.course') }}{{ $t('colon') }}</span
        >{{
          getSortCourseName(
            info.courseName.split(',').filter((item) => item !== '')
          )
        }}
      </p>
      <p v-if="info.taughtSubjects">
        <span class="lab">{{ $t('form.subject2') }}{{ $t('colon') }}</span
        ><span :title="getSubject(info.taughtSubjects)">{{
          getSubject(info.taughtSubjects)
        }}</span>
      </p>
      <p v-if="info.teachingExperience">
        <span class="lab">{{ $t('form.background') }}{{ $t('colon') }}</span
        >{{ info.teachingExperience }} {{ info.teachingExperience>1?$t('year'):$t('singerYear') }}
      </p>
      <p v-if="info.commentStar">
        <span class="lab">{{ $t('form.rating') }}{{ $t('colon') }}</span
        ><el-rate
          class="rate"
          v-model="info.commentStar"
          disabled
          show-score
          text-color="#ff9900"
          score-template="{value}"
        ></el-rate>
      </p>
      <router-link
        :to="{ path: '/teachers/teacherDetail', query: { id: info.teacherId } }"
        class="ui-btn blue phone-btn"
        >{{ $t('common.teacherinfo') }}</router-link
      >
    </div>
  </div>
</template>
<script>
import { reloadErrorImg } from '@/service/util.js'
export default {
  props: ['info', 'showOrder'],
  data() {
    return {
      // univercityArr: [],
      // collegeArr: []
    }
  },
  methods: {
    getEducation(n) {
      switch (n) {
        case 1:
          return this.$t('education.level1')
          break
        case 2:
          return this.$t('education.level2')
          break
        case 3:
          return this.$t('education.level3')
          break
        case 4:
          return this.$t('education.level4')
          break
        case 5:
          return this.$t('education.level5')
          break
        case 6:
          return this.$t('education.level6')
          break
      }
    },
    getSortCourseName(arr) {
      arr.sort((s, t) => {
        let a = s.toLowerCase()
        let b = t.toLowerCase()
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      return arr.join(', ')
    },
    getSubject(arr2) {
      let arr = JSON.parse(JSON.stringify(arr2)) // 不能直接修改参数，不然会出现无限轮循报错
      arr.sort(function (a, b) {
        let nameA = a.subjectName.toUpperCase()
        let nameB = b.subjectName.toUpperCase()
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        return 0
      })

      let name = ''
      for (let i = 0; i < arr.length; i++) {
        if (i != 0 && arr[i].subjectName === arr[i - 1].subjectName) {
        } else {
          if (i != 0) {
            name += ', '
          }

          name += arr[i].subjectName
          if (arr[i].mark) {
            name += ': ' + arr[i].mark
          }
        }
      }
      return name
    },
    reloadImg(url) {
      return reloadErrorImg(url)
    },
  },
  // watch: {
  //   info: function(val){
  //     this.univercityArr = val.universitys.split(",")
  //     this.collegeArr = val.colleges.split(",")
  //   }
  // }
  // computed: {
  //   univercityArr: function(){
  //     if(this.info.universitys){
  //       return this.info.universitys.split(',')
  //     }else{
  //       return ''
  //     }
  //   },
  //   collegeArr: function(){
  //     if(this.info.colleges){
  //       return this.info.colleges.split(',')
  //     }else{
  //       return ''
  //     }
  //   }
  // }
}
</script>
<style lang="scss" scoped>
.video {
  display: block;
  float: right;
  width: 108px;
  height: 40px;
  background: url(../assets/video.png) no-repeat;
  background-size: cover;
  position: relative;
  top: 0px;
  right: 10px;
}
.video-cn {
  background: url(../assets/video-cn.png) no-repeat;
  background-size: 100%;
}
.video-TW {
  background: url(../assets/video-tw.png) no-repeat;
  background-size: 100%;
}
.teacherCard {
  overflow: hidden;
  padding: 30px;
}
.avatar {
  float: left;
  width: 320px;
  height: 320px;
  position: relative;
  font-size: 0;
  margin-right: 50px;
  .img {
    width: 100%;
    height: 100%;
  }
}
// .tip{
//   position: absolute; top: -12px; right: -15px; width: 111px; height: 111px; background: url(../assets/triangle2.png); text-align: center;
//   .txt{display: inline-block; font-size: 21px; transform: rotate(45deg); color: #fff; transform-origin: 0 141%;}
// }
.btns {
  float: right;
  width: 236px;
  padding: 26px 0 0 30px;
  text-align: left;
  margin: 33px 0 0 10px;
  height: 267px;
  border-left: 1px solid #dcdcdc;
  text-align: center;
  .ui-btn {
    margin-top: 30px;
  }
}
.info {
  overflow: hidden;
  p {
    margin-bottom: 10px;
    font-size: 18px;
    color: #555;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .name {
    font-size: 36px;
    color: #002147;
    line-height: 64px;
    .txt {
      display: inline-block;
      max-width: 420px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      vertical-align: top;
    }
  }
  .lab {
    color: #000;
  }
}
.tag {
  display: inline-block;
  margin: 0 30px 20px 0;
  padding: 0 16px;
  height: 24px;
  line-height: 24px;
  border-radius: 24px;
  background: #a9c4b1;
  color: #fff;
  font-size: 14px;
}
.phone-btn {
  display: none;
}
.rate {
  display: inline-block;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .info .name {
    font-size: 25px;
  }
  .avatar {
    // width: 100%;
  }
  .info {
    width: 100%;
  }
  .btns {
    display: none !important;
  }
  .phone-btn {
    display: block;
    font-size: 16px;
  }
}
</style>